import React, { useState, useEffect } from 'react';
import axios from 'axios';

const MyBookings = () => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBookings();
  }, []);

  const fetchBookings = async () => {
    try {
      const response = await axios.get('/api/bookings/my-bookings');
      setBookings(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
    }
  };

  const handleCancel = async (id) => {
    if (!window.confirm('Cancel this booking?')) return;
    try {
      await axios.put(`/api/bookings/${id}/cancel`);
      fetchBookings();
    } catch (error) {
      alert('Failed to cancel booking');
    }
  };

  if (loading) return <div style={styles.loading}>Loading...</div>;

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>My Bookings</h1>
      
      {bookings.length === 0 ? (
        <div style={styles.empty}>
          <p>No bookings yet!</p>
          <a href="/activities"><button className="btn btn-primary">Browse Activities</button></a>
        </div>
      ) : (
        <div style={styles.grid}>
          {bookings.map(booking => (
            <div key={booking._id} style={styles.card}>
              <div style={styles.cardHeader}>
                <h3>{booking.activityName}</h3>
                <span style={{
                  ...styles.status,
                  background: booking.status === 'confirmed' ? '#4CAF50' : 
                             booking.status === 'cancelled' ? '#F44336' : '#FF9800'
                }}>
                  {booking.status}
                </span>
              </div>
              
              <div style={styles.details}>
                <p> {booking.activityDay}</p>
                <p> {booking.activityTime}</p>
                <p> KES {booking.price}</p>
                <p> Booked: {new Date(booking.bookingDate).toLocaleDateString()}</p>
              </div>

              {booking.notes && (
                <div style={styles.notes}>
                  <strong>Notes:</strong> {booking.notes}
                </div>
              )}

              {booking.status === 'confirmed' && (
                <button 
                  onClick={() => handleCancel(booking._id)}
                  className="btn btn-outline"
                  style={{width: '100%', marginTop: '1rem'}}
                >
                  Cancel Booking
                </button>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const styles = {
  container: { maxWidth: '1200px', margin: '2rem auto', padding: '0 2rem' },
  loading: { textAlign: 'center', padding: '4rem', fontSize: '1.2rem' },
  title: { fontSize: '3rem', textAlign: 'center', marginBottom: '3rem', fontFamily: 'Playfair Display, serif' },
  empty: { textAlign: 'center', padding: '4rem' },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: '2rem' },
  card: { background: 'white', padding: '1.5rem', borderRadius: '20px', boxShadow: '0 4px 16px rgba(0,0,0,0.1)' },
  cardHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' },
  status: { color: 'white', padding: '0.5rem 1rem', borderRadius: '20px', fontSize: '0.85rem', fontWeight: 600, textTransform: 'uppercase' },
  details: { borderTop: '1px solid #eee', paddingTop: '1rem', marginTop: '1rem' },
  notes: { background: '#f9f9f9', padding: '1rem', borderRadius: '8px', marginTop: '1rem' }
};

export default MyBookings;